<template>
  <div
    class="relative cursor-pointer"
    @click="$emit('click', $event)"
    @touchstart="onTouchstart"
    @touchmove="onTouchmove"
    @touchend="onTouchend"
  >
    <div class="menu-inner-container">
      <svg
        id="menu-complete"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="0 0 383 383"
        fill="white"
      >
        <g id="menu-top" transform="translate(58.477)">
          <path
            id="menu-section-accent-outer-2"
            d="M423.708,77.5l-4.285,4.285-7.975,7.98a174.007,174.007,0,0,0-229.96,0l-9.077-9.1-3.2-3.2a191.237,191.237,0,0,1,254.48,0Z"
            transform="translate(-163.457 -28.999)"
            opacity="0.1"
          />
          <path
            id="menu-section-accent-outer-1"
            d="M421.234,97.441l-5.789,5.872c-.617-.613-.041-.046-.663-.645l-2.218,2.213q-3.855-3.855-7.943-7.449a174.007,174.007,0,0,0-229.96,0q-3.622,3.2-7.065,6.58l-2.232-2.209-.585.562c-.457.457-.915.883-1.344,1.331l-5.68-5.945-1.125-1.171q4.285-4.285,8.954-8.245c19.49-16.577,43.227-28.512,68.172-36.437.384-.123.768-.252,1.152-.366a187.547,187.547,0,0,1,55.7-8.414c46.886,0,89.217,17.756,121.986,46.319q3.837,3.347,7.495,6.887l.5.48C421.234,97.441,420.6,96.805,421.234,97.441Z"
            transform="translate(-156.63 -36.663)"
            opacity="0.1"
          />
        </g>
        <g id="menu-left" transform="translate(0 59.914)">
          <path
            id="menu-section-accent-outer-2-2"
            data-name="menu-section-accent-outer-2"
            d="M89.634,411.649l-9.21,9.214-3.2,3.2a191.246,191.246,0,0,1,0-254.485l4.285,4.285,7.984,7.984a174.007,174.007,0,0,0,.128,229.814Z"
            transform="translate(-28.751 -165.208)"
            opacity="0.1"
          />
          <path
            id="menu-section-accent-outer-1-2"
            data-name="menu-section-accent-outer-1"
            d="M103.871,413.526l-2.346,2.369c.416.434.841.869,1.267,1.3l.626.631-5.945,5.7-1.152,1.107q-4.3-4.3-8.231-8.954C71.5,396.186,59.565,372.448,51.635,347.5c-.123-.38-.247-.768-.361-1.152a187.374,187.374,0,0,1-8.414-55.7c0-46.886,17.756-89.217,46.319-121.986q3.311-3.8,6.832-7.445l.53-.549.626-.645,5.867,5.785h0c-.613.617-.046.041-.649.663l2.213,2.218q-3.846,3.855-7.44,7.952a174.007,174.007,0,0,0,.128,229.814Q100.483,410.083,103.871,413.526Z"
            transform="translate(-36.408 -160.02)"
            opacity="0.1"
          />
        </g>
        <g id="menu-bottom" transform="translate(59.931 238.704)">
          <path
            id="menu-section-accent-outer-2-3"
            data-name="menu-section-accent-outer-2"
            d="M423.815,745.886a191.246,191.246,0,0,1-254.484,0l12.429-12.429a174,174,0,0,0,229.59-.037Z"
            transform="translate(-164.977 -650.002)"
            opacity="0.1"
          />
          <path
            id="menu-section-accent-outer-1-3"
            data-name="menu-section-accent-outer-1"
            d="M424.414,725.668q-4.3,4.3-8.954,8.231c-19.49,16.613-43.227,28.535-68.172,36.459l-1.152.366a187.52,187.52,0,0,1-55.7,8.414c-46.886,0-89.217-17.756-121.986-46.319q-3.832-3.347-7.495-6.887l-.5-.457-.645-.622,5.789-5.895c.617.613.041.041.663.645l2.369-2.364q3.859,3.841,7.961,7.435a174,174,0,0,0,229.59-.037q3.626-3.178,7.074-6.567l2.424,2.4.59-.567,1.34-1.326,5.679,5.945Z"
            transform="translate(-159.81 -641.221)"
            opacity="0.1"
          />
        </g>
        <g id="menu-right" transform="translate(239.526 58.574)">
          <path
            id="menu-section-accent-outer-2-4"
            data-name="menu-section-accent-outer-2"
            d="M794,296.946a190.551,190.551,0,0,1-48.472,127.245l-4.285-4.285-8.163-8.153a174.007,174.007,0,0,0,.192-229.773l12.26-12.26A190.551,190.551,0,0,1,794,296.946Z"
            transform="translate(-650.526 -163.944)"
            opacity="0.1"
          />
          <path
            id="menu-section-accent-outer-1-4"
            data-name="menu-section-accent-outer-1"
            d="M778.7,291.061c0,46.886-17.761,89.221-46.319,121.99q-3.329,3.8-6.859,7.445l-.53.549-.627.645-5.862-5.789h0c.608-.613.041-.037.645-.663l-2.4-2.405q3.855-3.855,7.449-7.943a174.007,174.007,0,0,0,.192-229.773q-3.2-3.631-6.571-7.074l2.2-2.218c-.416-.457-.841-.869-1.267-1.3-.206-.215-.416-.425-.626-.636l5.945-5.693,1.152-1.107q4.3,4.3,8.254,8.954c16.577,19.49,28.512,43.223,36.441,68.172.124.38.247.764.361,1.148a187.422,187.422,0,0,1,8.428,55.7Z"
            transform="translate(-641.664 -157.09)"
            opacity="0.1"
          />
        </g>
        <circle cx="191.5" cy="191.5" r="178" opacity="0.2" />
      </svg>
      <div class="informative-content">
        <information-paragraph>{{ informativeContent }}</information-paragraph>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InformationParagraph from "@/components/nav/InformationParagraph.vue";

export default {
  name: "CircularMenuInformative",
  props: {
    informativeContent: {
      type: String,
      default: ""
    },
    levelSwitchBus: {
      type: Vue,
      required: true
    }
  },
  components: {
    InformationParagraph
  },
  methods: {
    onTouchstart(e) {
      this.levelSwitchBus.$emit("touch-start", e);
    },
    onTouchmove(e) {
      this.levelSwitchBus.$emit("touch-move", e);
    },
    onTouchend() {
      this.levelSwitchBus.$emit("touch-end");
    }
  }
};
</script>

<style>
.menu-inner-container {
  width: 24rem;
  max-width: 24rem;
  height: 24rem;
  max-height: 24rem;
  margin: auto;
}
.informative-content {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0;
  width: 24rem;
  max-width: 24rem;
  padding: 10% 5%;
  height: 100%;
  text-align: center;
  justify-content: space-around;
}

@media (min-width: 1024px) {
  .menu-inner-container,
  .informative-content {
    width: 30rem;
    height: 30rem;
    max-height: 30rem;
    max-width: 30rem;
  }
}
</style>
